<template>
  <div>
    <div class="mgt-20px">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle  }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-error" @click="retour">
              {{ $t('general.button.cancel') }}
            </button>
            <button class="button is-addOrEdit" @click="sauvegarde(true)"
                    v-if="afficherNextStep()">
              {{ $t('dispositifPublicitaire.nextStep') }}
            </button>
            <button class="button is-addOrEdit" @click="sauvegarde(false)">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <piece-jointe-button
              class="mgr-2"
              :disabled="step === 2"
              :perm="permEmplacement.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="mgt-20px">
        <div>
          <div class="steps-utilisateur">
            <app-steps v-if="!$route.params.idDispositif && !$route.params.idMateriel"
                       :steps="getStepLibelle" :actualStep="step" :isVertical="false">
            </app-steps>
          </div>
          <informations-generation-code-dispositif  v-if="step === 0 && emplacement"
                                        :element="dispositifPublicitaire"
                                        :emplacement="emplacement"
          />
          <informations-generation-code-materiel v-if="step === 1 && materiel"
                                    :element="materiel"
                                    :dispositif="dispositifPublicitaire"
          />
          <informations-generation-code-face v-if="step === 2 && materiel"
                                    :materiel="materiel"
                                    :dispositif="dispositifPublicitaire"
          />
          <error-msg-component :messages="messages"
                               :error="error"
                               :messagesChampsVide="messagesChampsVide"
                               :champsVide="champsVide"
                               :title="'editionClient.problemOccurred'"
                               :withEmplyFields="true"
                               @close="error = $event"
          />
          <dispositif-information  v-if="step === 0"
                                   :dispositifPublicitaire="dispositifPublicitaire">
          </dispositif-information>
          <materiel v-if="step === 1" :materiel="materiel"
            @hasNewLogo="hasNewLogo = $event">
          </materiel>
          <face v-if="step === 2 && !estNumerique" :materiel="materiel"></face>
        </div>
      </div>
    </div>
    <b-modal v-model="showPopUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('materiel.saveActions')"
        :questions="messagesPreventions"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.apply')"
        @validateQuestions="applyPrevChoices"
        @no="showPopUpPrevention = false">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererDispositifPublicitaire from '@/services/gabed/emplacement/generer/genererDispositifPublicitaire';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { get as getEmplacement } from '@/api/gabed/emplacement';
import { create as createDispositif, get as getDispositif } from '@/api/gabed/dispositif';
import {
  create as createMateriel,
  synchroniserLogoMateriel,
  update as updateMateriel,
} from '@/api/gabed/materiel';
import AppSteps from '@/components/general/steps';
import dispositifInformation from '@/components/gabed/dispositif/m_dispositifInformation';
import messageSucces from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import inProgress from '@/services/general/inProgress';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import translate from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import materiel from '@/components/gabed/materiel/m_materiel';
import genererMateriel from '@/services/gabed/materiel/genererMateriel';
import face from '@/components/gabed/face/m_face';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import informationsGenerationCodeDispositif from '@/components/gabed/dispositif/informationsGenerationCodeDispositif';
import informationsGenerationCodeMateriel from '@/components/gabed/materiel/informationsGenerationCodeMateriel';
import informationsGenerationCodeFace from '@/components/gabed/face/informationsGenerationCodeFace';
import popUpPrevention from '@/components/general/popUpPrevention';
import { DECLARATION_EN_ATTENTE } from '@/configuration/gabed/materiel/materielConf';
import { MONTE, DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import breadcrumb from '@/components/general/breadcrumb';

const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'm_managerStepDispositifMaterielFace',
  data() {
    return {
      dispositifPublicitaire: genererDispositifPublicitaire(),
      materiel: genererMateriel(),
      permEmplacement: EMPLACEMENT,
      emplacement: null,
      step: 0,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      hasNewLogo: false,
      showPopUpPrevention: false,
      messagesPreventions: [],
      logoPj: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    AppSteps,
    dispositifInformation,
    materiel,
    face,
    errorMsgComponent,
    informationsGenerationCodeDispositif,
    informationsGenerationCodeMateriel,
    informationsGenerationCodeFace,
    popUpPrevention,
    pieceJointeButton,
  },
  methods: {
    afficherNextStep() {
      if (this.step === 2 || this.step === 1 && this.estNumerique) return false;
      if (!this.$route.params.idDispositif && !this.$route.params.idMateriel) return true;
      return false;
    },
    ...Attachments.mapActions({
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
      setAttachmentContext: 'setContext',
      updateLogoForFace: 'updateLogo',
      loadAttachments: 'loadAttachments',
    }),
    sauvegarde(goToNextStep) {
      if (this.step === 0) {
        this.saveDispositif(goToNextStep);
      } else if (this.step === 1) {
        this.saveMateriel(goToNextStep, false);
      } else if (this.step === 2) {
        this.openPopUpPrevention();
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    retour() {
      this.$router.go(-1);
    },
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationGeneral(this.$i18n, response, this.champsVide, this.messages,
        this.messagesChampsVide, translate);
      validationPatrimoine(response, this.messages);
      this.error = true;
    },
    async saveMateriel(goToNextStep, propagationLogo) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        if (!this.logoPj) this.logoPj = this.logo;
        const materielInformation = cloneDeep(this.materiel);
        materielInformation.dateMontage = formatIsoDate(materielInformation.dateMontage);
        materielInformation.dateDemontage = formatIsoDate(materielInformation.dateDemontage);
        if (materielInformation.nomenclature) {
          materielInformation.nomenclature = JSON.stringify(materielInformation.nomenclature);
        }
        materielInformation.faces.forEach((face) => {
          if (!face.id) {
            delete face.id;
          }
          face.dateMontage = formatIsoDate(face.dateMontage);
          face.dateDemontage = formatIsoDate(face.dateDemontage);
        });
        if (this.$route.params.idMateriel || this.materiel.id) {
          const materiel = (await updateMateriel(materielInformation)).data.result;
          materiel.faces.forEach((face) => {
            face.dateMontage = this.materiel.dateMontage;
            face.dateDemontage = this.materiel.dateDemontage;
            this.modificationDateMontageDemontage(face);
            face.etat = this.materiel.etat;
          });
          this.materiel = this.modificationDateMontageDemontage(materiel);
          if (this.hasNewLogo && propagationLogo) {
            const params = {
              elementId: this.materiel.id,
              conserveAnciennePj: this.logoPj.conserveAnciennePj,
            };
            await synchroniserLogoMateriel(params);
            this.hasNewLogo = false;
            this.logoPj = null;
          }
          messageSucces(this.$t('materiel.modification'));
          loadingComponent.close();
          return this.$router.push({
            name: 'c.gabed.emplacement-detailMateriel',
            params: { idMateriel: this.materiel.id },
          });
        }
        materielInformation.dispositifId = this.dispositifPublicitaire.id === undefined
          ? this.$route.params.idDispositifExistant : this.dispositifPublicitaire.id;
        const materiel = (await createMateriel(materielInformation)).data.result;
        materiel.faces.forEach((face) => {
          this.modificationDateMontageDemontage(face);
        });
        this.materiel = await this.modificationDateMontageDemontage(materiel);
        await this.setAttachmentElementId({ id: this.materiel.id });
        await this.insertAttachments(this.materiel.id);
        messageSucces(this.$t('materiel.success'));
        loadingComponent.close();
        if (!goToNextStep || (this.step === 1 && this.estNumerique)) {
          return this.$router.replace({
            name: 'c.gabed.emplacement-detailMateriel',
            params: { idMateriel: this.materiel.id },
          });
        }
        this.step += 1;
        this.error = false;
        return '';
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
    },
    modificationDateMontageDemontage(objectInformation) {
      objectInformation.dateMontage = objectInformation.dateMontage !== null ? new Date(
        objectInformation.dateMontage,
      ) : null;
      objectInformation.dateDemontage = objectInformation.dateDemontage !== null ? new Date(
        objectInformation.dateDemontage,
      ) : null;
      if (objectInformation.nomenclature) {
        objectInformation.nomenclature = JSON.parse(objectInformation.nomenclature);
      }
      return objectInformation;
    },
    async saveDispositif(goToNextStep) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        const dispositifInformation = cloneDeep(this.dispositifPublicitaire);
        dispositifInformation.dateMontage = formatIsoDate(dispositifInformation.dateMontage);
        dispositifInformation.dateDemontage = formatIsoDate(dispositifInformation.dateDemontage);
        if (dispositifInformation.nomenclature) {
          dispositifInformation.nomenclature = JSON.stringify(dispositifInformation.nomenclature);
        }
        const dispositifPublicitaire = (await createDispositif(dispositifInformation)).data.result;
        await this.setAttachmentElementId({ id: dispositifPublicitaire.id });
        await this.insertAttachments(dispositifPublicitaire.id);
        this.dispositifPublicitaire = this.modificationDateMontageDemontage(
          dispositifPublicitaire,
        );
        this.materiel.dispositif = cloneDeep(this.dispositifPublicitaire);
        this.materiel.dateMontage = this.dispositifPublicitaire.dateMontage;
        this.materiel.dateDemontage = this.dispositifPublicitaire.dateDemontage;
        this.materiel.etat = this.dispositifPublicitaire.etat;
        this.changeEtatTlpeMateriel();
        messageSucces(this.$t('dispositifPublicitaire.success'));
        loadingComponent.close();
        if (goToNextStep) {
          this.error = false;
          this.step += 1;
          return '';
        }
        return this.$router.replace({
          name: 'c.gabed.emplacement-detailDispositif',
          params: { idDispositif: this.dispositifPublicitaire.id },
        });
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    openPopUpPrevention() {
      this.messagesPreventions = [];
      if (this.hasNewLogo) {
        this.messagesPreventions.push({
          key: 1,
          message: 'materiel.copyImageSurProduits',
          value: true,
        });
        this.showPopUpPrevention = true;
      } else this.saveMateriel(false);
    },
    async applyPrevChoices(values) {
      let propagationLogo = false;
      if (values && values
        .find((q) => { return q.key === 1; })) {
        propagationLogo = this.messagesPreventions.find((q) => {
          return q.key === 1;
        }).value;
      }
      this.showPopUpPrevention = false;
      await this.saveMateriel(false, propagationLogo);
    },
    changeEtatTlpeMateriel() {
      switch (this.materiel.etat) {
        case MONTE:
          this.materiel.etatMontageTlpe = DECLARATION_EN_ATTENTE;
          break;
        case DEMONTE:
          this.materiel.etatDemontageTlpe = DECLARATION_EN_ATTENTE;
          break;
        default:
          break;
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Attachments.mapGetters({
      logo: 'logo',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
      ];
      if (this.$route.params.id) {
        output.push({ title: this.$i18n.t('detailEmplacement.titleWithoutN'), route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.$route.params.id } }, isActive: false });
        output.push({ title: this.$i18n.t('dispositifPublicitaire.dispositif'), route: '', isActive: true });
      }
      return output;
    },
    estNumerique() {
      return (this.materiel && this.materiel.numerique);
    },
    getTitle() {
      if (this.step === 0) {
        this.setInformationPage(this.$t('pagePatrimoine.emplacement.dispositifPublicitaire.creation'));
        return this.$t('dispositifPublicitaire.title');
      }
      if (this.step === 1) {
        this.setInformationPage(this.$t('pagePatrimoine.emplacement.materiel.creation'));
        if (this.estNumerique) return this.$t('materiel.titleNumerique');
        return this.$t('materiel.title');
      }
      if (this.step === 2) {
        this.setInformationPage(this.$t('pagePatrimoine.emplacement.face.creation'));
        return this.$t('face.title');
      }
      return '';
    },
    getStepLibelle() {
      const steps = [
        { title: this.$i18n.t('dispositifPublicitaire.steps.etape1'), sousTitle: this.$i18n.t('dispositifPublicitaire.steps.dispositif'), step: 1 },
        { title: this.$i18n.t('dispositifPublicitaire.steps.etape2'), sousTitle: this.$i18n.t('dispositifPublicitaire.steps.materiel'), step: 2 },
      ];
      if (!this.estNumerique) {
        steps.push(
          { title: this.$i18n.t('dispositifPublicitaire.steps.etape3'), sousTitle: this.$i18n.t('dispositifPublicitaire.steps.faces'), step: 3 },
        );
      }
      return steps;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.idDispositif || this.$route.params.idDispositifExistant) {
        const dispositif = (await getDispositif(
          this.$route.params.idDispositif
            ? this.$route.params.idDispositif : this.$route.params.idDispositifExistant,
        )).data.result;
        this.dispositifPublicitaire = this.modificationDateMontageDemontage(dispositif);
        this.emplacement = this.dispositifPublicitaire.emplacement;
        this.materiel.dispositif = cloneDeep(this.dispositifPublicitaire);
        this.materiel.dateMontage = this.dispositifPublicitaire.dateMontage;
        this.materiel.dateDemontage = this.dispositifPublicitaire.dateDemontage;
        this.materiel.etat = this.dispositifPublicitaire.etat;
        this.changeEtatTlpeMateriel();
        if (this.$route.params.idDispositifExistant) {
          this.step = 1;
        }
      } else {
        this.emplacement = (await getEmplacement(
          this.$route.params.id,
        )).data.result;
        this.dispositifPublicitaire.emplacement = this.emplacement;
        this.dispositifPublicitaire.emplacementId = this.emplacement.id;
        this.dispositifPublicitaire.adresse = this.emplacement.adresseCadastrale;
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
